import { render, staticRenderFns } from "./MenuReportRoster.vue?vue&type=template&id=012f5d64&"
import script from "./MenuReportRoster.vue?vue&type=script&lang=js&"
export * from "./MenuReportRoster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports